import { EventBus } from "../../../eventbus";
import { setDocTitle } from "../../../functions/HelperFuncs";
import { download } from "../../../functions/download";

export default {
  data() {
    return {
      id: this.$options.name,
      doneSearching: false,
      selectedFiles: [],
    };
  },

  created() {
    setDocTitle("Download collection", this);

    EventBus.$on("mobile-download-collection--download", () => {
      //download files
      this.downloadCollection();
    });

    EventBus.$on(`files-holder-update`, (data) => {
      this.selectedFiles = data.selectedFiles;
    });
  },
  methods: {
    downloadCollection() {
      download(
        {
          type: "multi",
          items: {
            selectedFiles: [...this.$store.state.collectForDownload],
            selectedFolders: [],
            collection: {},
          },
          btn: e.event.currentTarget,
        },
        this
      );
    },

    deleteDownloadItem() {
      const toRemoveFiles = this.selectedFiles;
      let newDownloadCollection = [...this.$store.state.collectForDownload];

      newDownloadCollection = newDownloadCollection.filter((colItem) => {
        let keep = true;

        toRemoveFiles.forEach((delFile) => {
          if (delFile === colItem.id) {
            //delete me
            keep = false;
          }
        });

        return keep;
      });

      //reset selectedFiles
      this.selectedFiles = [];

      //set new download collection
      localStorage.setItem(
        "collectForDownload",
        JSON.stringify(newDownloadCollection)
      );

      this.$store.state.collectForDownload = newDownloadCollection;
    },
  },
};
